import { TenantDocuments, TenantDocumentsLanguages } from '../../@types/types'

export const tenantDocumentsLanguages: TenantDocumentsLanguages = {
  selfReport: { translation: 'Self Report' },
  solvency: { translation: 'Schufa-Credit check' },
  rental: { translation: 'Payment confirmation' },
  identification: { translation: 'Proof of identity' },
  income: { translation: 'Proof of income' },
}

export const allTenantDocuments: (keyof TenantDocuments)[] = [
  'selfReport',
  'solvency',
  'rental',
  'identification',
  'income',
]
